<template>
    <div>
        <mu-carousel>
            <mu-carousel-item>
                <img src="../assets/b1.png">
            </mu-carousel-item>
            <mu-carousel-item>
                <img src="../assets/b2.png">
            </mu-carousel-item>
        </mu-carousel>

    </div>
</template>

<script>
    export default {
        name: 'carousel',
    }
</script>


// WEBPACK FOOTER //
// src/components/carousel.vue